import type { TimeSlot, TransportMode } from "../types";

/** 编辑卡片、交通编辑与行程表格共用四种交通类型，不按班次细分。 */
export const ITINERARY_TRANSPORT_LABELS: Record<TransportMode, string> = {
  walk: "步行", bus: "大巴", rail: "火车", air: "飞机",
};

/** 行程编辑器可持久化的时段顺序。 */
export const ITINERARY_TIME_SLOTS: readonly TimeSlot[] = ["morning", "afternoon", "evening"];
export const ITINERARY_MIN_DAYS = 1;
export const ITINERARY_MAX_DAYS = 30;

/** 编辑器右栏功能入口；新增标签统一在本模块登记。 */
export const ITINERARY_SIDE_TABS = [
  { key: "customization", title: "定制信息", description: "当前行程关联的需求版本" },
  { key: "preview", title: "行程预览", description: "展示已保存内容，保存成功后自动刷新" },
  { key: "table", title: "行程表格", description: "当前编辑内容，随草稿实时更新" },
] as const;
